import React, { FC } from 'react';
import Image from 'next/image';
import { styled } from 'linaria/react';
import { useDidMount } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
import { Content, Spacer } from '@shared/ui/atoms';
import { homeErrorShowGtm } from '@shared/lib/gtm/redesign';
import errorDark from '@shared/assets/images/cyber/errorDark.png';
const TemporarilyUnavailablePageView: FC = () => {
  useDidMount(() => {
    homeErrorShowGtm('servis_vremenno_nedostupen');
  });
  return <Content.Margin bottom={16} mobBottom={8} minBottom={2}>
      <Wrapper>
        <ErrorLoadWrapper>
          <WrapperIcon>
            <Image src={errorDark} className="icon" alt="error500" height={120} width={120} />
          </WrapperIcon>
          <Spacer space={24} />
          <Text>Сервис временно недоступен</Text>
          <Spacer space={8} />
          <Desc>Попробуйте обновить страницу или вернуться позднее</Desc>
        </ErrorLoadWrapper>
      </Wrapper>
    </Content.Margin>;
};
export default TemporarilyUnavailablePageView;
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w9j3t59",
  propsAsIs: false
});
const ErrorLoadWrapper = /*#__PURE__*/styled('div')({
  name: "ErrorLoadWrapper",
  class: "e1e5lvuq",
  propsAsIs: false
});
const WrapperIcon = /*#__PURE__*/styled('div')({
  name: "WrapperIcon",
  class: "w10rmd7h",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.white;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.lg;
const Text = withTheme(/*#__PURE__*/styled('div')({
  name: "Text",
  class: "ta2nmnk",
  propsAsIs: false,
  vars: {
    "ta2nmnk-0": [_exp()],
    "ta2nmnk-1": [_exp2(), "px"],
    "ta2nmnk-2": [_exp3()],
    "ta2nmnk-3": [_exp4()],
    "ta2nmnk-4": [_exp5(), "px"]
  }
}));
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.tertiary;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp8 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSText;
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const Desc = withTheme(/*#__PURE__*/styled('div')({
  name: "Desc",
  class: "d82utr7",
  propsAsIs: false,
  vars: {
    "d82utr7-0": [_exp6()],
    "d82utr7-1": [_exp7(), "px"],
    "d82utr7-2": [_exp8()],
    "d82utr7-3": [_exp9()],
    "d82utr7-4": [_exp0(), "px"]
  }
}));

require("./TemporarilyUnavailablePageView.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./TemporarilyUnavailablePageView.tsx");